import React from "react";

import { combineClassNames } from "../../utils/appUtils";
import WPButton from "../../packages/WPButton";

import "./index.css";

const WPTertiaryButton = ({
  id,
  label,
  onClick,
  disabled,
  icon,
  size,
  tabIndex,
  className,
  preventDefault,
  variant = "text",
  type = "primary",
  iconPlacement = "after",
  tooltip,
  tooltipPlacement = "top",
}) => {
  return (
    <WPButton
      id={id}
      size={size}
      disabled={disabled}
      onClick={onClick}
      preventDefault={preventDefault}
      variant={variant}
      type={type}
      tooltip={tooltip}
      tooltipPlacement={tooltipPlacement}
      customClass={combineClassNames("wp-tertiary-button", className)}
      tabIndex={tabIndex}
    >
      {icon && iconPlacement === "before" && (
        <span className="tertiary-btn-icon-wrapper">{icon}</span>
      )}
      {label}
      {icon && iconPlacement === "after" && (
        <span className="tertiary-btn-icon-wrapper">{icon}</span>
      )}
    </WPButton>
  );
};

export default WPTertiaryButton;
